<template>
    <div>
        <!-- 头部 -->
        <div class="headT">
            <div class="pageW">
                <p class="headTab">
                    <a v-for="(item, index) in tabData" :key="index" @click="goRouter(item, index)">
                        {{ item.name }}
                    </a>
                </p>
                <el-input class="input-with-select" placeholder="输入关键词" v-model="selectInps">
                    <el-button slot="append" icon="el-icon-search" @click="goSeach"></el-button>
                </el-input>
            </div>
        </div>
        <div class="pageW">
            <el-carousel class="el-carousel levelBannerImgs" v-if="bannerData && bannerData[16]"
                :indicator-position="(bannerData[16].list.length > 1 ? '' : 'none')" :autoplay="true" arrow="never"
                :interval="8000">
                <el-carousel-item v-for="(item, index) in bannerData[16].list" :key="index">
                    <img :src="item.url" @click="imgRouter(item)" />
                </el-carousel-item>
            </el-carousel>
            <!-- <img class="pageBanner" src="https://gygg.cnxz.com.cn/uploadfiles/20211207114102_10819.jpg" /> -->
            <div class="news">
                <div class="news_l">
                    <div class="textDetail">
                        <p class="textDetail_local">
                            <img src="http://hfy-img.xzyunchuang.com/00067b6b77f1b7ca60e62ea17d706cd9" />
                            <b>当前位置：</b>
                            <span  @click="backIndex">首页</span> >
                            <span @click="importNews(item)" v-for="(item, index) in detailData.columnPath" :key="index">
                                {{ item.columnName }}>
                            </span>
                            <a>正文</a>
                        </p>
                        <p class="textDetail_tit">
                            {{ detailData.title }}
                        </p>
                        <p class="textDetail_info">
                            <span> {{ detailData.publishDate }}</span>
                            <span>来源：{{ detailData.source }}</span>
                            <span>编辑：{{ detailData.editor }}</span>
                            <span v-if="detailData.author">作者：{{ detailData.author }}</span>
                        </p>
                        <!-- 徐州网事 模块需要添加视频 -->
                        <div style="margin:20px 0;" v-if="detailData.videoUrl">
                            <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true"
                            :options="playerOptions"
                            @error="onError"
                            ></video-player>
                        </div>
                        <!-- 文章内容 -->
                        <div class="textDetail_Cont" v-html="detailData.content"></div>
                        <div class="dataInfo" v-if="noData">
                            <p>暂无内容信息</p>
                            <span>返回首页</span>
                        </div>
                        <div class="loadingInfo" v-if="loading">
                            <img src="http://hfy-img.xzyunchuang.com/a64cc6ed942b4fbd676693a5fa7241f5" />
                            <p>正在努力加载中……</p>
                        </div>
                        <div>
                            <p class="phoneList">
                                新闻爆料：0516-82345678　　商务合作：0516-85792397　13775881757
                            </p>
                            <p class="tishi">
                                版权声明： 徐州报业传媒集团旗下媒体徐州日报、彭城晚报、都市晨报、中国徐州网所发表之文章与图片，受《中华人民共和国著作权法》的保护，未经书面许可不得转载。
                                部分网站的侵权行为，如擅自转载、更改消息来源以及抄袭等，徐州报业传媒集团及其旗下媒体已经委托有关部门收集相关证据。
                                本站部分资源来自网络，如有侵犯您的版权及其他权益，请及时与我们联系，我们将核实情况后进行相关删除!
                            </p>
                        </div>
                    </div>
                    <!-- <p class="contentTit">继续阅读</p>
                    <ul>
                        <li v-for="(item, index) in 6" :key="index">
                            <img src="https://gygg.cnxz.com.cn/uploadfiles/20211207114102_10819.jpg" />
                            <div>
                                <p>新思想引领新时代改革开放｜推动中国特色社会主义制度更加成熟更加｜推动中国特色社会主义制度更加成熟更加定｜推动中国特色社会主义制度更加成熟更加定｜推动中国特色社会主义制度更加成熟更加定定
                                </p>
                                <span>2024-07-02</span>
                            </div>
                        </li>
                    </ul> -->
                </div>
                <div class="news_r">
                    <tabRight :bannerData="bannerData"></tabRight>
                </div>
            </div>
        </div>
        <div class="shareT" :style="{ 'top': topHeight + 'px' }">
            <a @click="shareTo('http://service.weibo.com/share/share.php?', 'weibo')" title="分享到新浪微博"></a>
            <el-popover placement="right" width="200" trigger="hover" @show="creatQrCode">
                <!-- content="这是一段内容,这是一段内容,这是一段 ?>  内容,这是一段内容。" -->
                <div class="qrcode">
                    <p>分享到微信朋友圈</p>
                    <canvas ref="qrCodeUrl" id="QRCode_header" style="width: 180px; height: 180px">

                    </canvas>
                    <p>
                        打开微信，点击底部的“发现”，
                        <br />
                        使用“扫一扫”即可将网页分享至朋友圈。
                    </p>
                </div>
                <el-button class="shareToIcon" slot="reference">
                </el-button>
            </el-popover>

            <a @click="shareTo('https://connect.qq.com/widget/shareqq/index.html?', 'qzone')"></a>
            <a @click="shareTo('https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?', 'qzone')"></a>
            <a>
                <el-popover  placement="right" title="" width="260" trigger="hover">
                    <p v-if="detailDatas.prevArticle"  class="leftp" @click="goDetail(detaidetailDataslData.prevArticle.id)">
                        上一篇：{{ detailDatas.prevArticle.title }}
                    </p>
                    <p v-else style="color: #999;">暂无上一篇内容</p>
                    <span slot="reference" class="leftStart" @click="goDetail(detailDatas.prevArticle.id)"></span>
                </el-popover>
            </a>
            <a>
                <el-popover  placement="right" title="" width="260" trigger="hover">
                    <p v-if="detailDatas.nextArticle" class="leftp" @click="goDetail(detailDatas.nextArticle.id)">
                        下一篇：{{ detailDatas.nextArticle.title }}
                    </p>
                    <p v-else style="color: #999;">暂无下一篇内容</p>
                    <span slot="reference" class="leftStart" @click="goDetail(detailDatas.nextArticle.id)"></span>
                </el-popover>
            </a>
        </div>


        <!-- 分享文章 -->
        <bot></bot>
        <!-- 返回顶部 -->
        <div class="backT">
            <el-backtop class="backTop" :bottom="100">
                <div class="backUp">
                    <img src="http://hfy-img.xzyunchuang.com/31d99fe61a7f789f4c805b234c2b07e6" />
                </div>
            </el-backtop>
        </div>
    </div>
</template>
<script>
import 'video.js/dist/video-js.css';
import 'vue-video-player/src/custom-theme.css'
import { videoPlayer } from "vue-video-player";
import { Carousel, CarouselItem } from 'element-ui'
import QRCode from "qrcode"; //引入生成二维码插件
import {
    indexAdList
} from "@/api/index.js";

import {
    articleDetail,relateNews
} from "@/api/news.js";
export default {
    components: {
        'el-carousel': Carousel,
        'el-carousel-item': CarouselItem,
        videoPlayer,
    },
    data() {
        return {
            topHeight: 155,
            loading: true,
            tabData: [
                { name: '首页', id: null, linkUrl: '/', route: '' },
                { name: '徐州新闻', id: '1', linkUrl: '', route: '' },
                { name: '县域新闻', id: '19', linkUrl: '/countyLevel', route: '' },
                { name: '网罗天下', id: '10', linkUrl: '', route: '' },
                { name: '彭城e评', id: '6', linkUrl: '', route: '' },
                { name: '徐州发布', id: '', linkUrl: '', route: '' },
                { name: '徐州网视', id: '1833803344738340864', linkUrl: '', route: '' },
                { name: '数字报', id: '', linkUrl: 'http://epaper.cnxz.com.cn/xzrb/html/2024-08/09/node_2.htm', route: '' }
            ],
            query: {},
            bannerData: [],
            selectInps: '',//搜索
            detailData: {},
            detailDatas: {},
            noData:false,
            text: 'fsdsdsdsdsdsdsdsdsdsdsdsdsdsdsdsdsdsdsdsd',
            url: '',
            qrCodeValue: 'https://www.jb51.net/javascript/310081jwr.htm',
            titleCon: '',
            playerOptions: {
                playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
                autoplay: false, // 如果为true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 是否视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [{
                src: '' // url地址
                }],
                poster: '', // 封面地址
                notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                timeDivider: true, // 当前时间和持续时间的分隔符
                durationDisplay: true, // 显示持续时间
                volumeMenuButton: true, //音量控制
                remainingTimeDisplay: false, // 是否显示剩余时间功能
                fullscreenToggle: true // 是否显示全屏按钮
                }
            },
            errorMessage:{
                1: '网络连接异常，请检查网络连接',
                2: '所请求的视频文件格式不支持',
                3: '视频文件正在加载，请稍候再试',
            }
        }
    },
    // components: {
    //     VueQrcode
    // },
    mounted() {
        if (this.$route.query && this.$route.query.DetailId) {
            this.query.id = this.$route.query.DetailId;
        }
        this.detail();
        var that = this;
        window.addEventListener('scroll', function () {
            // 在这里编写需要执行的代码
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (scrollTop > 60 && that.topHeight > 0) {
                that.topHeight = (200 - scrollTop) > 0 ? (200 - scrollTop) : 0;
            } else if (scrollTop < 60) {
                that.topHeight = 155;
            }
        });

    },
    methods: {
        onError(data) {
        // 使用修改后的错误提示信息
        this.$refs.videoPlayer.$emit('error-display', {
            type: 'error',
            message: this.errorMessage[data.code]
        });
        },
        backIndex() {
            window.open('/', "_blank");
        },
        importNews(item){
            window.open('/importNews?id='+item.id +'&tab=-1&tabName='+item.columnName, "_self");
        },
        goSeach() {
            window.open('/seach?name=' + this.selectInps, "_blank");
        },
        goRouter(item, index) {
            if (item.linkUrl) {
                window.open(item.linkUrl, "_blank");
            } else {
                window.open('/importNews?id=' + item.id + '&tab=' + index, "_blank");
            }
        },
        getImgUrl(html) {
            // let htmlContent = el.getAttribute('v-img-html');
            // 创建DOM元素
            // const div = document.createElement('div');
            // div.innerHTML = html;

            // // 遍历所有的img元素，并设置宽度
            // const images = div.querySelectorAll('img');
            // images.forEach(img => {
            //    img.height = ' '; // 或者其他你想要的宽度值
            // });
            html = html.replaceAll("(<img[^>]*?)\\s+width\\s*=\\s*\\S+","$1");
            html = html.replaceAll("(<img[^>]*?)\\s+height\\s*=\\s*\\S+","$1");
            return html;
            // return div.innerHTML;
        },
        detail() {
            // 顶部轮播图
            indexAdList({}).then(res => {
                this.bannerData = res.data;
            })
            articleDetail(this.query).then(res => {
                this.detailData = res.data;
                this.detailData.content=this.getImgUrl(this.detailData.content);
                document.title = this.detailData.title;
                if(!this.detailData.content){
                    this.noData=true;
                }
                if(res.data.videoUrl){

                }
                this.playerOptions.poster = res.data.imgUrl + '?imageView2/2/w/676/h/505';
                this.playerOptions.sources[0].src = res.data.videoUrl;
                this.titleCon= this.detailData.title;
                this.loading = false;
            })
            relateNews(this.query).then(res => {
                this.detailDatas= res.data;
            })

        },
        imgRouter(item, index) {
            console.log(item)
            if (item.type == 1 && item.relateId) {
                window.open(item.relateId, "_blank")
            }
            else if (item.type == 2) {
                window.open('/newsDetail?DetailId=' + item.relateId, "_blank");
            }
            else if (item.type == 3) {
                if (index) {
                    window.open('/spacilPage1', "_blank");
                    return;
                }
                if (item.module) {
                    window.open('/topList?topic=' + item.relateId, "_blank");
                } else {
                    window.open('/topList1?topic=' + JSON.stringify({ topic: item.relateId }), "_blank");
                }
            }
        },
        goDetail(id) {
            window.open('/newsDetail?DetailId=' + id, '_self');
        },
        creatQrCode() {
            const canvas = this.$refs.qrCodeUrl;
            let optin = {
                width: 180,
                height: 180
            }
            QRCode.toCanvas(canvas, location.href, optin, function (error) {
            })
        },
        getQRCode() {
            //生成的二维码为URL地址js
            let qrUrl = location.href;
            let opts = {
                errorCorrectionLevel: "H", //容错级别
                type: "image/png", //生成的二维码类型
                quality: 0.3, //二维码质量
                margin: 0, //二维码留白边距
                width: 180, //宽
                height: 180, //高
                text: location.href, //二维码内容
                color: {
                    dark: "#333333", //前景色
                    light: "#fff", //背景色
                },
            };

            let msg = document.getElementById("QRCode_header");
            // 将获取到的数据（val）画到msg（canvas）上
            QRCode.toCanvas(msg, qrUrl, opts, function (error) {
                if (error) {
                    console.log("二维码加载失败", error);
                    // this.$message.error("二维码加载失败");
                }
            });
        },
        // sharetos(){
        //     &sharesource=weibo&title=徐州文旅淮海经济区宣传推广活动举行%20-%20中国徐州网&pic=http://www.cnxz.com.cn/style2021/picture/logo2.jpg&appkey=2706825840
        // }
        shareTo(_shareUrl, sharesource) {
            this.url = location.href;
            // event.preventDefault()
            // shareUrl是微博的分享地址，（有资料说需要真实的appkey，必选参数，这里我没用appkey也可以正常分享）
            // var _shareUrl = 'http://service.weibo.com/share/share.php?'
            // 微博
            // https://service.weibo.com/share/share.php?url=https://www.cnxz.com.cn/newscenter/2024/20240829268656.shtml&sharesource=weibo&title=%E7%8E%8B%E5%89%91%E9%94%8B%E4%BB%A5%E2%80%9C%E5%9B%9B%E4%B8%8D%E4%B8%A4%E7%9B%B4%E2%80%9D%E6%96%B9%E5%BC%8F%E8%B0%83%E7%A0%94%E7%AA%81%E5%87%BA%E7%94%9F%E6%80%81%E7%8E%AF%E5%A2%83%E9%97%AE%E9%A2%98%20-%20%E4%B8%AD%E5%9B%BD%E5%BE%90%E5%B7%9E%E7%BD%91&pic=http://www.cnxz.com.cn/style2021/picture/logo2.jpg&appkey=2706825840
            // qq
            // https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=https://www.cnxz.com.cn/newscenter/2024/20240829268656.shtml&sharesource=qzone&title=%E7%8E%8B%E5%89%91%E9%94%8B%E4%BB%A5%E2%80%9C%E5%9B%9B%E4%B8%8D%E4%B8%A4%E7%9B%B4%E2%80%9D%E6%96%B9%E5%BC%8F%E8%B0%83%E7%A0%94%E7%AA%81%E5%87%BA%E7%94%9F%E6%80%81%E7%8E%AF%E5%A2%83%E9%97%AE%E9%A2%98%20-%20%E4%B8%AD%E5%9B%BD%E5%BE%90%E5%B7%9E%E7%BD%91&pics=http://www.cnxz.com.cn/style2021/picture/logo2.jpg&summary=%E4%B8%AD%E5%9B%BD%E5%BE%90%E5%B7%9E%E7%BD%91%20-%20%E6%AC%B2%E7%9F%A5%E5%BE%90%E5%B7%9E%E4%BA%8B,%E7%82%B9%E5%87%BB%E5%BE%90%E5%B7%9E%E7%BD%91%EF%BC%81%E5%8C%85%E5%90%AB%E6%9C%89%E5%BE%90%E5%B7%9E%E6%96%B0%E9%97%BB,%E6%96%B0%E9%97%BB%E4%B8%AD%E5%BF%83,%E6%96%B0%E9%97%BB%E4%B8%93%E9%A2%98,%E5%BE%90%E5%B7%9E%E5%8F%91%E5%B8%83%E7%AD%89%E7%BB%BC%E5%90%88%E6%96%B0%E9%97%BB%E9%97%A8%E6%88%B7%E7%BD%91%E7%AB%99
            _shareUrl += 'url=' + encodeURIComponent(this.url) //参数url设置分享的内容链接
            _shareUrl += '&url=' + encodeURIComponent(this.url)
            _shareUrl += '&title=' + encodeURIComponent(this.titleCon) + '%20-%20中国徐州网&pics=http://www.cnxz.com.cn/style2021/picture/logo2.jpg&summary=中国徐州网%20-%20欲知徐州事,点击徐州网！包含有徐州新闻,新闻中心,新闻专题,徐州发布等综合新闻门户网站' //参数title设置分享的标题
            // 保留当前页面,打开一个非tab页面（按需求来，可以新开标签页，也可以在当前页新开页面）
            window.open(
                _shareUrl,
                '_blank',
            )
        }
    }

}
</script>
<style lang="scss">
.vjs-custom-skin>.video-js .vjs-big-play-button {
  height: 2em !important;
  line-height: 2em !important;
  border-radius: 50%;
  width: 2em !important;
  margin-left: -0.6em;
}

.vjs-custom-skin>.video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  margin-top: -0.6em !important;
}
.vjs-error .vjs-error-display .vjs-modal-dialog-content{
  display: none !important;
}
.vjs-error .vjs-error-display:before{
  content: '资源加载失败' !important;
  font-size: 1.7em !important;
}
.vjs-custom-skin>.video-js .vjs-big-play-button {
  // height: 1.25em !important;
  // line-height: 1.15em !important;
  border-radius: 50%;
  // width: 1.3em !important;
  margin-left: -0.6em;
}

.video-js.vjs-fluid {
  height: 480px !important;
}

/deep/ .culumn_video {
  .video-js.vjs-fluid:not(.vjs-audio-only-mode) {
    height: 480px !important;
  }

  .video-player {
    .vjs-fluid {
      height: 480px !important;
    }
  }
}
</style>
<style scoped>
img {
    /*max-width: 100% !important;*/
    max-width: 100% !important;
}
.textDetail_Cont{
    text-align: justify;
}
.textDetail_Cont p{
    margin-bottom: 15px !important;
}
</style>
<style scoped lang="scss">
img {
        max-width: 100% !important;
    }

    video {
        max-width: 100% !important;
    }
.dataInfo{
    margin: 50px 0;
    p{
        color: #666;
        margin-bottom: 20px;
    }
    span{
        background: #921515;
        color: #fff;
        display: inline-block;
        padding: 4px 16px;
        border-radius: 2px;
    }
}

/deep/.textDetail_Cont {
    overflow-x: hidden;
    // font-size: 16px !important;
    line-height: 28px !important;
    color: #333 !important;
    p{
        // color: #333 !important;
        padding: 0;
        padding-bottom: 15px;
        margin-bottom: 15px !important;
    }
    img {
        //max-width: 100% !important;
        max-width: 90% ;
        width: 90%;
    }

    video {
        max-width: 100% !important;
    }
}

.headT {
    height: 40px;
    background: #c71f1f;
    width: 100%;

    .pageW {
        display: flex;
        justify-content: space-between;
    }


    .headTab {
        color: #fff;

        a {
            padding: 0 8px;
            font-size: 14px;
            margin-right: 10px;
            height: 40px;
            display: inline-block;
            line-height: 40px;
            cursor: pointer;

            &:hover {
                background: #921515;
            }
        }
    }
}

/deep/ .input-with-select {
    margin-top: 7.5px;
    height: 25px;
    line-height: 25px;
    font-size: 13px;
    width: 250px;

    .el-input__inner {
        height: 27px;
        line-height: 27px;
        border-right: none;
    }

    .el-input-group__append {
        height: 25px;
        line-height: 25px;
        background: #fff;
        padding: 0 10px;
        border-color: #fff;
    }
}

.news {
    display: flex;
    justify-content: space-between;
    margin-bottom: 60px;

    &_l {
        // flex: 1;
        margin-right: 20px;
        width: calc(100% - 440px);

        .textDetail {
            &_local {
                font-size: 14px;
                display: flex;
                align-items: center;
                margin-bottom: 10px;

                img {
                    width: 150px;
                    margin-right: 20px;
                }
                span{
                    cursor: pointer;
                }

            }

            &_tit {
                margin: 20px 0;
                font-size: 26px;
                font-weight: bold;
                line-height: 40px;
                text-align: justify;
            }

            &_info {
                font-size: 14px;
                border-bottom: 1px solid #e1e1e1;
                color: #999;
                margin-bottom: 20px;
                line-height: 26px;
                padding-bottom: 15px;

                span {
                    margin-right: 24px;
                }
            }

            .phoneList {
                margin: 80px 0 20px 0;
                font-weight: bold;
                font-size: 14px;
                border-bottom: 1px solid #e1e1e1;
                padding-bottom: 20px;
            }

            .tishi {
                color: #ee1c24;
                padding-top: 15px;
                font-size: 14px;
                line-height: 20px;
                margin-bottom: 20px;
                padding-bottom: 50px;
                border-bottom: 3px solid #ee1c24;
            }
        }

        ul {}

        li {
            display: flex;
            justify-content: space-between;
            width: 100%;
            padding: 20px 0;
            border-bottom: 1px solid #E4E4E4;

            img {
                width: 180px;
                height: 120px;
                margin-right: 20px;
            }

            span {
                color: #979A9C;
                font-size: 13px;
                width: 120px;
            }
        }
    }

    &_r {
        width: 324px;

        img {
            max-width: 100%;
        }

        .newsList {
            background: #F9F9F9;
        }
    }
}

// 最新咨询
/deep/ .new_c {
    .el-carousel__arrow {
        top: 92px !important;
    }

    .new_Item {
        padding-bottom: 10px;

        p {
            padding: 10px 20px;
        }

        span {
            color: #979A9C;
            font-size: 12px;
            margin: 0 20px;
        }
    }
}

.contentTit {
    font-weight: bold;
}

.shareT {
    position: fixed;
    left: 50%;
    top: 220px;
    z-index: 99;
    margin-left: 170px;
    display: flex;
    flex-direction: column;

    .shareToIcon {
        border: none;
        width: 25px;
        height: 25px;
        margin-bottom: 12px;
        background: url('http://hfy-img.xzyunchuang.com/b3213aea44ca6f07efd5dbf25d199713') no-repeat left top;

    }

    .leftp {
        cursor: pointer;
    }

    a {
        width: 25px;
        height: 25px;
        margin-bottom: 12px;
        position: relative;
        cursor: pointer;

        .leftStart {
            position: absolute;
            left: 0;
            top: 0;
            width: 25px;
            height: 25px;
        }

        &:nth-child(1) {
            background: url('http://hfy-img.xzyunchuang.com/2906a2e734beecb8f7ee7961561f6c2d') no-repeat left top;
        }

        &:nth-child(2) {
            background: url('http://hfy-img.xzyunchuang.com/b3213aea44ca6f07efd5dbf25d199713') no-repeat left top;
        }

        &:nth-child(3) {
            background: url('http://hfy-img.xzyunchuang.com/9efa05a8813a2a0fa738459d8f29bd85') no-repeat left top;
        }

        &:nth-child(4) {
            background: url('http://hfy-img.xzyunchuang.com/91f6fb07c7c16504be862592067e60a3') no-repeat left top;
        }

        &:nth-child(5) {
            background: url('http://hfy-img.xzyunchuang.com/ad58bb319bc443755fec296b22b17e0a') no-repeat left top;
        }

        &:nth-child(6) {
            background: url('http://hfy-img.xzyunchuang.com/bf88645766fe88693c95b326281c290b') no-repeat left top;
        }
    }

}

.qrcode {
    font-size: 12px;
    color: #333;
    text-align: center;

    p {
        margin: 10px 0;
        text-align: left;
    }
}

.backT {
    position: fixed;
    left: 50%;
    bottom: 0px;
    margin-left: 548px;
}

.backUp {

    // background: #fff;
    // border:1px solid 999;
    img {
        width: 30px;
    }
}

/deep/ .backTop {
    border-radius: 0 !important;
    width: 46px;
    height: 46px;
    position: relative;
    // box-shadow:0 0 0 #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/newsDetail.vue